export default __webpack_public_path__ + "static/media/leader_notes_detailed.2f984d00.pdf";